import React from 'react';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Select,
} from '@chakra-ui/react';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  error?: string;
  helperText?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  options,
  error,
  helperText,
  isRequired = false,
  isDisabled = false,
  size = 'md',
}) => {
  return (
    <FormControl
      isRequired={isRequired}
      isInvalid={!!error}
      isDisabled={isDisabled}
    >
      {label && (
        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
          {label}
        </FormLabel>
      )}
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        size={size}
        bg="white"
        borderColor="gray.300"
        _hover={{ borderColor: 'gray.400' }}
        _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px blue.500' }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {error && <FormErrorMessage fontSize="sm">{error}</FormErrorMessage>}
      {helperText && !error && (
        <FormHelperText fontSize="sm" color="gray.600">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
